import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "content p-4" }
const _hoisted_3 = { class: "line-clamp-2 text-white" }
const _hoisted_4 = { class: "flex items-center gap-3 flex-wrap mt-1.5 text-xs text-gray-400 font-semibold" }
const _hoisted_5 = { class: "flex gap-1 items-center" }

import { Icon } from "@iconify/vue";
import { demoThumbnailUrl } from "../data/data";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoCart',
  props: ["video"],
  setup(__props) {

const props = __props;
const data: Video = props?.video;

const {
  id: { videoId },
  snippet: {
    channelTitle,
    thumbnails: { high },
    publishedAt,
    title,
  },
} = data;
const fromNow = moment(publishedAt).fromNow();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/watch/${_unref(videoId)}`,
    class: "video-cart bg-bg_secondary transition-all duration-300 hover:scale-105 w-full h-full block"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _unref(high).url || _unref(demoThumbnailUrl),
        alt: _unref(title),
        class: "w-full aspect-[3/2] object-cover"
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(title)), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(channelTitle)), 1),
            _createElementVNode("span", null, [
              _createVNode(_unref(Icon), { icon: "lets-icons:check-fill" })
            ])
          ]),
          _createElementVNode("p", null, _toDisplayString(_unref(fromNow)), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})